import service from "@/store/services/registrations-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  registration: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, registration) => {
    state.registration = registration;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },

  getReceipt({ commit, dispatch }, params) {
    return service.getReceipt(params, this.$axios);
  },
 
  sendReceipt({ commit, dispatch }, params) {
    return service.sendReceipt(params, this.$axios);
  },

  redraft({ commit, dispatch }, params) {
    return service.redraft(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },

  complete({ commit, dispatch }, params) {
    return service.complete(params, this.$axios).then((registration) => {
      commit("SET_RESOURCE", registration);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  registration: (state) => state.registration,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((registration) => ({
      id: registration.id,
      name: registration.code,
    }));
  },
};

const registrations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default registrations;
